<div class="public-page">
  <div class="public-page__navbar">
    <div class="public-page__navbar__wrapper">
      <a [href]="homePageUrl" class="public-page__navbar__link-root">
        <img src="assets/img/azavista-color.png" alt="Azavista" />
      </a>
      <mat-select class="public-page__navbar__language-selector" [(ngModel)]="language" (selectionChange)="onLanguageSelected($event.value)">
        @for (lang of availableLanguages; track lang) {
          <mat-option [value]="lang.id">{{lang.label}}</mat-option>
        }
      </mat-select>
    </div>
  </div>
  <div class="public-page__content">
    <div class="public-page__content__news">
      <iframe [src]="iframeUrl | apply : sanitize"></iframe>
    </div>
    <div class="public-page__content__main">
      <ng-content></ng-content>
    </div>
  </div>
</div>
